import { Axios, AxiosRequestConfig, AxiosResponse } from 'axios'
import AxiosClientProvider from './AxiosClientProvider'
export class HttpClient {
    private instance: Axios
    constructor(options: any) {
        this.instance = new AxiosClientProvider(options).getClient()
    }

    get<T = any, R = AxiosResponse<T>, D = any>(
        url: string,
        config?: AxiosRequestConfig<D>,
    ): Promise<R> {
        return this.instance.get(url, config)
    }

    post<T = any, R = AxiosResponse<T>>(
        url: string,
        data?: T,
        config?: AxiosRequestConfig,
    ): Promise<R> {
        return this.instance.post<T, R>(url, data, config)
    }

    put<T = any, R = AxiosResponse<T>>(
        url: string,
        data?: T,
        config?: AxiosRequestConfig,
    ): Promise<R> {
        return this.instance.put<T, R>(url, data, config)
    }
    patch<T = any, R = AxiosResponse<T>>(
        url: string,
        data?: T,
        config?: AxiosRequestConfig,
    ): Promise<R> {
        return this.instance.patch<T, R>(url, data, config)
    }

    delete<T = any, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
        return this.instance.delete<T, R>(url, config)
    }
}
